export const numberToFormValue = (value: number | null): string => `${value ?? ''}`;

/** Converts a form value (string usually) to a number of null, which is what we use outside the form */
export const formValueToNumber = (value: number | string | undefined | null): number | null =>
  parseInt((value || '') as string, 10) || null;
